// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"85d271d8779795f88872","532":"bb3321a5517db56a7154","691":"1c4bd459c4d4558a1f11"}[chunkId] + ".js";
};